import React from 'react'
import { Text, TextColor, TextType } from '@sendoutcards/quantum-design-ui'

// types __________________________________________________
type ComponentProps = {
  children: string
} & Partial<DefaultProps>

type DefaultProps = Readonly<typeof defaultProps>

type Props = ComponentProps & DefaultProps

const defaultProps = {
  color: 'primaryBody' as TextColor,
  type: 'body' as TextType,
}

// component ______________________________________________
const Label: React.FC<Props> = ({
  children,
  color = defaultProps.color,
  type = defaultProps.type,
}) => (
  <Text type={type} color={color}>
    {children}
  </Text>
)

// export _________________________________________________
export default Label
